import { parsePhoneNumber } from "react-phone-number-input";

export const normalizePhoneNumber = (phoneNumber?: string | null): string => {
  if (!phoneNumber) {
    return "";
  }

  try {
    return parsePhoneNumber(phoneNumber, "US")?.number || phoneNumber;
  } catch {
    return phoneNumber;
  }
};
